<script setup>
import { inject, ref } from 'vue';
import { i18n } from '@/i18n';
import { Toaster } from '@/components/ui/toast';
import GDPR from './components/GDPR.vue';
const containerRef = ref(null);
inject('container', containerRef);
</script>

<template>
  <div ref="containerRef">
    <router-view :key="i18n.locale" />
    <Toaster />
    <GDPR />
  </div>
</template>

<style>
html,
body {
  overscroll-behavior-x: none;
  font-family:
    'Bricolage Grotesque', 'SF Pro SC', 'SF Pro Text', 'SF Pro Icons', 'PingFang SC',
    'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
}

/* 优化滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  transition: background-color 0.2s ease;
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.3);
}

/* Firefox 滚动条样式 */
* {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}
</style>
